// Tiny pub/sub between the version poller / service worker registration and
// the update UI (Sidebar button, mobile banner). Module-level singleton so
// every subscriber sees the same events regardless of how many components
// mount - see docs/implementation-plans/2026-09-29-app-version-update-banner.md.
const listeners = new Set();
let lastUpdateEvent = null;

export function subscribe(listener) {
  listeners.add(listener);
  // Update events fire once; replay so a component mounting later still sees them
  if (lastUpdateEvent) listener(lastUpdateEvent);
  return () => listeners.delete(listener);
}

export function publish(event) {
  if (event.type === "sw" || event.type === "version") lastUpdateEvent = event;
  listeners.forEach((listener) => listener(event));
}

export function __resetBusForTests() {
  listeners.clear();
  lastUpdateEvent = null;
}
